(() => {
  'use strict';

  const script = document.currentScript || document.querySelector('script[src*="abmium-cart-ui-sync.js"]');
  const headerCartSelector = '#header .abm-header-cart';
  const dockCartWrapSelector = '#mobile-dock .head-slot-cart-link-wrap';
  const fallbackCurrency = script?.dataset.currency || 'GBP';
  let refreshRequestId = 0;
  let refreshTimer = 0;

  const setCountBadge = (container, count) => {
    if (!container) return;
    const value = Math.max(0, Number(count) || 0);
    let badge = container.querySelector('.head-slot-cart-link-quantity');
    if (!value) {
      badge?.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'head-slot-cart-link-quantity';
      container.appendChild(badge);
    }
    badge.textContent = String(value);
    badge.hidden = false;
  };

  const syncCount = (count) => {
    const headerCart = document.querySelector(headerCartSelector);
    setCountBadge(headerCart?.querySelector('.abm-cart-icon'), count);
    setCountBadge(document.querySelector(dockCartWrapSelector), count);
  };

  const formatCartTotal = (cart) => {
    const amount = Math.max(0, Number(cart.total_price) || 0) / 100;
    const currency = cart.currency || fallbackCurrency || 'GBP';
    const locale = document.documentElement.lang || 'en-GB';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (_) {
      return `${currency} ${amount.toFixed(2)}`;
    }
  };

  const syncCartUI = (cart) => {
    if (!cart) return;
    syncCount(cart.item_count);

    const headerCart = document.querySelector(headerCartSelector);
    const copy = headerCart?.querySelector('.abm-header-action-copy');
    if (copy) {
      let total = copy.querySelector('.abm-header-cart-total') || copy.querySelector(':scope > span:nth-child(2)');
      if (!(Math.max(0, Number(cart.item_count) || 0))) {
        total?.remove();
      } else {
        if (!total) {
          total = document.createElement('span');
          copy.appendChild(total);
        }
        total.classList.add('abm-header-cart-total');
        total.textContent = `(${formatCartTotal(cart)})`;
      }
    }

    document.dispatchEvent(new CustomEvent('abmium:cart-synced', { detail: { cart } }));
  };

  const refreshCartUI = async () => {
    const requestId = ++refreshRequestId;
    try {
      const cartUrl = `${window.routes?.cart_url || '/cart'}.js`;
      const response = await fetch(cartUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestId === refreshRequestId) syncCartUI(cart);
    } catch (_) {}
  };

  const scheduleCartUIRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCartUI, 0);
  };

  const handleCartEvent = (event) => {
    const cart = event?.detail?.cart;
    if (cart && typeof cart === 'object') {
      refreshRequestId += 1;
      window.clearTimeout(refreshTimer);
      syncCartUI(cart);
      return;
    }

    const count = Number(event?.detail?.count);
    if (Number.isFinite(count)) syncCount(count);
    scheduleCartUIRefresh();
  };

  [
    'cart:item-add',
    'cart:item-remove',
    'cart:item-quantity-update',
    'cart:refresh',
    'cart:update',
    'cart:change',
    'abmium:cart'
  ].forEach((eventName) => document.addEventListener(eventName, handleCartEvent));

  document.addEventListener('shopify:section:load', () => {
    const headerBadge = document.querySelector(`${headerCartSelector} .head-slot-cart-link-quantity`);
    const dockBadge = document.querySelector('#mobile-dock .head-slot-cart-link-quantity');
    const count = Number.parseInt(headerBadge?.textContent || dockBadge?.textContent || '', 10);
    if (Number.isFinite(count)) syncCount(count);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) scheduleCartUIRefresh();
  });
})();
